<template>
    <div class="hero">
        <div :style="imagen1" class="hero__image">
        </div>
        <div class="hero__information">
           <Container>
               <div class="home__title">
                   <h1>ACELDAT-PERÚ</h1>
                   <p>Información Acelerométrica</p>
               </div>
                <p>ACELDAT-PERÚ es un servicio que el Instituto Geofísico del Perú 
                    pone a disposición de los científicos e ingenieros para la 
                    rápida disponibilidad de datos de aceleración del suelo 
                    registrados por la Red Acelerométrica Nacional después 
                    de ocurrido un sismo de magnitud igual o mayor a M4.5.</p>
                <p>Este servicio se ha fortalecido con la firma de convenios 
                    con el  Colegio de Ingenieros del Perú – Consejo Nacional
                     (CIP) y el Servicio Nacional de Capacitación para la
                      Industria de la Construcción (SENCICO), llegándose a
                       disponer de datos para mas de centena de sensores de
                        aceleración distribuidos en todo el país.</p>
                <ul>
                    <li>Para recibir reportes acelerométricos, subscribase.</li>
                </ul>
                <Button 
                    tag="a" 
                    theme="inverted" 
                    target="_blank" 
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeQBSjLkWWZnuT9osQC3DJBaFteTUnlRwrEw_dVwaXGj08J_A/viewform">
                    <Icon svg="email"/> Suscríbirse
                </Button>
           </Container>
        </div>
        <div :style="imagen2" class="hero__image">
        </div>
    </div>

</template>

<script>
// import HeroGrid from "@/components/home/HeroGrid";
import Container from "@/components/ui/objects/Container";
import Button from "@/components/ui/atoms/Button";
import Icon from "@/components/ui/atoms/Icon";
export default {
    
  components: {
    // HeroGrid,
    Container,
    Button,
    Icon
  },
   

 
  data() {
      return{
          repEmitidos: 0,
          estAcel: 0,
          imagen1: { backgroundImage: "url(images/back_1.jpg)" },
          imagen2: { backgroundImage: "url(images/back_2.jpg)" },
      }
    },
     mounted(){
    },
  

}
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
    @media (max-width: 768px) {
        .hero{
            display: block;
        }
    }

     @media (min-width: 769px) {
         .hero{
        display: grid;
        grid-template-columns: repeat(3, 2fr);
        grid-auto-rows: minmax(500px, auto);
         }
    }

    .hero{

        &__information{
            background-color: variables.$primary-color;
            padding: 8rem 1rem;
        }
        &__image{
            background-position: center;
            background-size: cover;
        }
    }
    p{
        padding-top: 3rem;
        color: #fff;
    }

    .home__title{
        color: #fff;
        text-align: center;
    }
    .home__title>h1{
        padding-bottom: 0px;
        margin-bottom: 0px;
    }

    .home__title>p{
        padding-top: 0px;
    }

    ul{
        padding-top: 1rem;
        color: #fff;
        margin-left: -20px;
    }

    li:before { 
        content: '➤'; 
        margin-left: -20px; 
        margin-right: 10px; 
    } 
    a{
       margin-left: 22px; 
    }

</style>
